export default __webpack_public_path__ + "static/media/gastronovas2.3dfc0daa.jpg";